import React from "react";
import { Affix, Group } from "@mantine/core";

import { type SpaceContext } from "@piqnt/runtime-space/space";

import { CustomScrollbars } from "@piqnt/runtime-core/react/CustomScrollbars";
import { useMiddleware } from "@piqnt/runtime-core/react/ReactMount";

import { SelectionView } from "./SelectionView";
import { SceneList } from "./SceneView";
import { OutlineToolbar } from "./OutlineToolbar";

import {
  affixPosition,
  affixStyle,
  dividerStyle,
  panelStyle,
  sectionStyle,
  topSpace,
} from "@piqnt/runtime-core/react/OutlineStyle";

export const PlainOutlinePanel = () => {
  const { context } = useMiddleware<SpaceContext>();
  if (context.activity?.value !== "mode:edit") return;
  return (
    <Affix position={affixPosition} style={affixStyle}>
      <div style={panelStyle}>
        <div style={topSpace}></div>
        <Group justify="end" gap={8} m={8}>
          <OutlineToolbar />
        </Group>
        <div style={dividerStyle} />
        <div style={sectionStyle}>
          <CustomScrollbars>
            <SelectionView />
          </CustomScrollbars>
        </div>
        <div style={dividerStyle} />
        <div style={sectionStyle}>
          <CustomScrollbars>
            <SceneList />
          </CustomScrollbars>
        </div>
      </div>
    </Affix>
  );
};
